// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.pdr-chart-container {
  min-height: 240px;
  min-width: 170px;
  width: 320px;
  background-color: #18244c; }

.pdr-chart-tooltip .tooltip-inner {
  background-color: unset !important; }

.pdr-summary-container {
  min-height: 50px;
  min-width: 170px;
  width: 320px;
  background-color: #18244c;
  line-height: 9px; }

.pdr-summary-container-card {
  background-color: #18244c;
  padding: 0; }

.pdr-summary-field-name {
  font-size: 8px;
  color: gray;
  padding-bottom: 5px; }

.pdr-summary-container-card-title {
  line-height: 5px; }

.PermitDischargeReport {
  color: #fff;
  background-color: #050e25;
  height: 88vh;
  width: calc(100% - 30px);
  margin: 0px;
  padding: 0px;
  margin-left: 10px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px; }
  .PermitDischargeReport .expand-container {
    position: absolute;
    top: 55px;
    left: 70px;
    height: 90vh !important;
    width: calc(100% - 100px);
    z-index: 100; }
  .PermitDischargeReport .expand-container .table-container {
    max-height: 84vh !important;
    margin-left: 15px !important;
    min-height: 84vh !important; }
  .PermitDischargeReport .mapboxgl-popup {
    max-width: 375px !important; }
  .PermitDischargeReport .mapboxgl-popup-content {
    padding: 0px;
    padding-top: 5px;
    min-width: 375px !important;
    opacity: .95;
    border-radius: 4px;
    width: 100% !important;
    background-color: transparent; }
  .PermitDischargeReport .mapboxgl-popup-close-button {
    display: none; }
  .PermitDischargeReport .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
    border-bottom-color: #18244c;
    opacity: .8; }
  .PermitDischargeReport .popup-container {
    padding-top: 7px;
    padding-bottom: 32px;
    padding-left: 10px;
    padding-right: 4px;
    font-size: 14px;
    min-width: 375px;
    background-color: #050E25;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: max-content;
    font-weight: 500;
    opacity: .95;
    text-align: center;
    height: 195px;
    line-height: 10px;
    font-family: "Urbanist";
    display: flex;
    flex-direction: column;
    width: max-content; }
  .PermitDischargeReport .popup-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start; }
  .PermitDischargeReport .popup-content-left {
    text-align: right;
    margin-right: 10px;
    min-width: 50px;
    max-width: 50px;
    line-height: 14px;
    white-space: pre-wrap; }
  .PermitDischargeReport .popup-content-left p {
    margin-bottom: 24px; }
  .PermitDischargeReport .popup-content-highlight {
    color: #49b4cd; }
  .PermitDischargeReport .popup-content-right {
    text-align: left;
    max-width: 290px;
    min-width: 250px;
    line-height: 14px;
    font-size: 18px;
    padding-right: 2px; }
  .PermitDischargeReport .popup-content-right p {
    margin-bottom: 24px; }
  .PermitDischargeReport .popup-content-right-triple {
    height: 30px;
    line-height: 18px; }
  .PermitDischargeReport .popup-content-right-double {
    height: 22px;
    line-height: 16px; }
  .PermitDischargeReport .popup-content-right-triple {
    height: 32px;
    line-height: 16px; }
  .PermitDischargeReport .report-options-button-container {
    width: 200px;
    display: inline-flex;
    flex-flow: row-reverse;
    background-color: #050e25; }
  .PermitDischargeReport .container {
    display: flex;
    padding: 0;
    height: 90%;
    margin-top: 8px;
    max-width: inherit; }
    .PermitDischargeReport .container input,
    .PermitDischargeReport .container select {
      margin-bottom: 50px; }
    .PermitDischargeReport .container .main-col {
      max-width: -webkit-fill-available; }
    .PermitDischargeReport .container .map-title {
      width: auto;
      white-space: nowrap;
      position: absolute;
      left: 59px;
      top: 0px;
      font-size: 1.25rem;
      padding: 5px;
      z-index: 90; }
    .PermitDischargeReport .container .table-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      position: relative;
      margin-left: 1px;
      margin-top: 10px;
      max-height: 40vh;
      overflow-y: auto; }
    .PermitDischargeReport .container .reportTable {
      min-height: 10vh;
      color: white; }
    .PermitDischargeReport .container .map-best-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      position: relative;
      height: 40vh;
      width: 100%;
      border-radius: 7px;
      padding: 0px !important; }
    .PermitDischargeReport .container .map-legend {
      width: 230px;
      position: absolute;
      border-radius: 5px;
      padding: 5px;
      right: 40px;
      bottom: 10px;
      padding-bottom: 10px;
      background-color: #18244c;
      z-index: 90;
      height: 180px; }
    .PermitDischargeReport .container .map-legend p {
      text-align: center;
      height: 15px; }
    .PermitDischargeReport .container .map-legend span {
      width: 100px;
      margin-left: 5px; }
    .PermitDischargeReport .container .map-legend-div {
      display: flex;
      flex-flow: column;
      height: 100%;
      flex-wrap: wrap; }
    .PermitDischargeReport .container .map-legend-dot-div {
      width: 70px;
      margin-left: 5px;
      white-space: nowrap; }
    .PermitDischargeReport .container .map-legend-dot {
      background-color: #4b5ea6;
      height: 14px;
      width: 14px;
      margin-left: 5px;
      margin-right: 5px;
      border-radius: 50%;
      display: inline-flex; }
    .PermitDischargeReport .container .expand-container-summary {
      position: absolute;
      top: 59px;
      left: 50px;
      height: 90vh !important;
      width: 95% !important;
      z-index: 100;
      padding-top: 45px !important;
      overflow: scroll !important;
      flex-flow: wrap; }
    .PermitDischargeReport .container .expand-summary-button {
      display: unset;
      position: absolute;
      top: 1px;
      left: 0px;
      z-index: 1001; }
    .PermitDischargeReport .container .summary-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      margin-top: 0px;
      margin-left: 5px;
      margin-right: 20px;
      padding-top: 0px;
      height: 40vh;
      width: 250px;
      overflow-x: hidden;
      overflow-y: scroll;
      flex-direction: column;
      border-radius: 7px; }
    .PermitDischargeReport .container .card {
      padding-left: 2px;
      width: 210px;
      line-height: 18px;
      margin-bottom: 10px;
      max-width: 210px; }
    .PermitDischargeReport .container .card-title {
      line-height: 5px;
      font-size: 1.2rem; }
    .PermitDischargeReport .container .summary-container-span {
      font-size: 1.2rem; }
    .PermitDischargeReport .container .te-primary {
      background-color: #050e25; }
    .PermitDischargeReport .container .te-secondary {
      background-color: #4fc32c; }
    .PermitDischargeReport .container .te-blue {
      background-color: #0b61bf; }
    .PermitDischargeReport .container .summary-button {
      width: 44px;
      display: inline-flex;
      align-self: flex-end;
      background-color: white; }
    .PermitDischargeReport .container .summary-top {
      width: 100px; }
    .PermitDischargeReport .container .summary-field-double {
      height: auto;
      line-height: 18px; }
    .PermitDischargeReport .container .chart-line-container {
      height: 100%;
      width: 100%;
      width: -webkit-fill-available;
      width: -moz-available;
      width: stretch; }
    .PermitDischargeReport .container .report-options {
      margin-top: 20px;
      text-align: right;
      margin-right: 10px; }
      .PermitDischargeReport .container .report-options button {
        background-color: #fff;
        border: unset;
        margin-left: 10px; }
      .PermitDischargeReport .container .report-options button:hover {
        background-color: #257ee0; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/reports/PermitDischargeReport/styles.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACdrD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB,EAAA;;AAG3B;EACE,kCAAkC,EAAA;;AAGpC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB,EAAA;;AAGlB;EACE,yBAAyB;EACzB,UAAU,EAAA;;AAGZ;EACE,cAAc;EACd,WAAW;EACX,mBAAmB,EAAA;;AAGrB;EACE,gBAAgB,EAAA;;AAGlB;EACE,WD5CqB;EC6CrB,yBDhCsC;ECiCtC,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAjDoB;EAkDpB,mBAlDoB;EAmDpB,iBAlDmB,EAAA;EAwCrB;IAaI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,yBAAyB;IACzB,YAAY,EAAA;EAlBhB;IAsBI,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B,EAAA;EAxB/B;IA6BI,2BAA2B,EAAA;EA7B/B;IAiCI,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAE3B,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B,EAAA;EAxCjC;IA4CI,aAAa,EAAA;EA5CjB;IAgDI,4BAA4B;IAC5B,WAAW,EAAA;EAjDf;IAqDI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,kBAAkB,EAAA;EAxEtB;IA4EI,aAAa;IACb,mBAAmB;IACnB,2BAA2B,EAAA;EA9E/B;IAkFI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,qBAAqB,EAAA;EAvFzB;IA2FI,mBAAmB,EAAA;EA3FvB;IA+FI,cAAc,EAAA;EA/FlB;IAmGI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB,EAAA;EAxGtB;IA4GI,mBAAmB,EAAA;EA5GvB;IAgHI,YAAY;IACZ,iBAAiB,EAAA;EAjHrB;IAqHI,YAAY;IACZ,iBAAiB,EAAA;EAtHrB;IA0HI,YAAY;IACZ,iBAAiB,EAAA;EA3HrB;IA+HI,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;IACtB,yBAAyB,EAAA;EAlI7B;IAsII,aAAa;IACb,UAAU;IACV,WAAW;IACX,eAAe;IACf,kBAAkB,EAAA;IA1ItB;;MA8IM,mBAAmB,EAAA;IA9IzB;MAkJM,iCAAiC,EAAA;IAlJvC;MAsJM,WAAW;MACX,mBAAmB;MACnB,kBAAkB;MAClB,UAAU;MACV,QAAQ;MACR,kBAAkB;MAClB,YAAY;MACZ,WAAW,EAAA;IA7JjB;MAiKM,yBDzM0B;MC0M1B,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;MAChB,gBAAgB;MAChB,gBAAgB,EAAA;IAzKtB;MA6KM,gBAAgB;MAChB,YAAY,EAAA;IA9KlB;MAkLM,yBD1N0B;MC2N1B,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,kBAAkB;MAClB,uBAAuB,EAAA;IA1L7B;MA8LM,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,YAAY;MACZ,oBAAoB;MACpB,yBAAyB;MACzB,WAAW;MACX,aAAa,EAAA;IAvMnB;MA2MM,kBAAkB;MAClB,YAAY,EAAA;IA5MlB;MAgNM,YAAY;MACZ,gBAAgB,EAAA;IAjNtB;MAqNM,aAAa;MACb,iBAAiB;MACjB,YAAY;MACZ,eAAe,EAAA;IAxNrB;MA4NM,WAAW;MACX,gBAAgB;MAChB,mBAAmB,EAAA;IA9NzB;MAkOM,yBAAyB;MACzB,YAAY;MACZ,WAAW;MACX,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;MAClB,oBAAoB,EAAA;IAxO1B;MA4OM,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,uBAAuB;MACvB,qBAAqB;MACrB,YAAY;MACZ,4BAA4B;MAC5B,2BAA2B;MAC3B,eAAe,EAAA;IApPrB;MAwPM,cAAc;MACd,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,aAAa,EAAA;IA5PnB;MAgQM,yBDxS0B;MCyS1B,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB;MAChB,YAAY;MACZ,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;MAClB,sBAAsB;MACtB,kBAAkB,EAAA;IA7QxB;MAiRM,iBAAiB;MACjB,YAAY;MACZ,iBAAiB;MACjB,mBAAmB;MACnB,gBAAgB,EAAA;IArRtB;MA0RM,gBAAgB;MAChB,iBAAiB,EAAA;IA3RvB;MA+RM,iBAAiB,EAAA;IA/RvB;MAmSM,yBAAyB,EAAA;IAnS/B;MAuSM,yBAAyB,EAAA;IAvS/B;MA2SM,yBAAyB,EAAA;IA3S/B;MA+SM,WAAW;MACX,oBAAoB;MACpB,oBAAoB;MACpB,uBAAuB,EAAA;IAlT7B;MAsTM,YAAY,EAAA;IAtTlB;MA0TM,YAAY;MACZ,iBAAiB,EAAA;IA3TvB;MA+TM,YAAY;MACZ,WAAW;MAEX,6BAA6B;MAC7B,qBAAc;MAAd,cAAc,EAAA;IAnUpB;MAuUM,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB,EAAA;MAzUxB;QA4UQ,sBAAsB;QACtB,aAAa;QACb,iBAAiB,EAAA;MA9UzB;QAkVQ,yBAAyB,EAAA","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../../../theme/_variables.scss\";\n\n$paddingLeftSize: 10px;\n$paddingTopSize: 10px;\n$tableDividerLineColor: #222224;\n$tableDividerLineBorderSize: 0.5px;\n$tableFontSize: 1.2vw;\n$positionTop: 140px;\n\n.pdr-chart-container {\n  min-height: 240px;\n  min-width: 170px;\n  width: 320px;\n  background-color: #18244c;\n}\n\n.pdr-chart-tooltip .tooltip-inner {\n  background-color: unset !important;\n}\n\n.pdr-summary-container {\n  min-height: 50px;\n  min-width: 170px;\n  width: 320px;\n  background-color: #18244c;\n  line-height: 9px;\n}\n\n.pdr-summary-container-card {\n  background-color: #18244c;\n  padding: 0;\n}\n\n.pdr-summary-field-name {\n  font-size: 8px;\n  color: gray;\n  padding-bottom: 5px;\n}\n\n.pdr-summary-container-card-title {\n  line-height: 5px;\n}\n\n.PermitDischargeReport {\n  color: $primaryFontColor;\n  background-color: $containerScreenBackgroundColor;\n  height: 88vh;\n  width: calc(100% - 30px);\n  margin: 0px;\n  padding: 0px;\n  margin-left: 10px;\n  padding-left: $paddingLeftSize;\n  padding-right: $paddingLeftSize;\n  padding-top: $paddingTopSize;\n\n  .expand-container {\n    position: absolute;\n    top: 55px;\n    left: 70px;\n    height: 90vh !important;\n    width: calc(100% - 100px);\n    z-index: 100;\n  }\n\n  .expand-container .table-container {\n    max-height: 84vh !important;\n    margin-left: 15px !important;\n    min-height: 84vh !important;\n  }\n\n\n  .mapboxgl-popup {\n    max-width: 375px !important;\n  }\n\n  .mapboxgl-popup-content {\n    padding: 0px;\n    padding-top: 5px;\n    min-width: 375px !important;\n   \n    opacity: .95;\n    border-radius: 4px;\n    width: 100% !important;\n    background-color: transparent;\n  }\n\n  .mapboxgl-popup-close-button {\n    display: none;\n  }\n\n  .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {\n    border-bottom-color: #18244c;\n    opacity: .8;\n  }\n\n  .popup-container {\n    padding-top: 7px;\n    padding-bottom: 32px;\n    padding-left: 10px;\n    padding-right: 4px;\n    font-size: 14px;\n    min-width: 375px;\n    background-color: #050E25;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    width: max-content;\n    font-weight: 500;\n    opacity: .95;\n    text-align: center;\n    height: 195px;\n    line-height: 10px;\n    font-family: \"Urbanist\";\n    display: flex;\n    flex-direction: column;\n    width: max-content;\n  }\n\n  .popup-content {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n\n  .popup-content-left {\n    text-align: right;\n    margin-right: 10px;\n    min-width: 50px;\n    max-width: 50px;\n    line-height: 14px;\n    white-space: pre-wrap;\n  }\n\n  .popup-content-left p {\n    margin-bottom: 24px;\n  }\n\n  .popup-content-highlight {\n    color: #49b4cd;\n  }\n\n  .popup-content-right {\n    text-align: left;\n    max-width: 290px;\n    min-width: 250px;\n    line-height: 14px;\n    font-size: 18px;\n    padding-right: 2px;\n  }\n\n  .popup-content-right p {\n    margin-bottom: 24px;\n  }\n\n  .popup-content-right-triple {\n    height: 30px;\n    line-height: 18px;\n  }\n\n  .popup-content-right-double {\n    height: 22px;\n    line-height: 16px;\n  }\n\n  .popup-content-right-triple {\n    height: 32px;\n    line-height: 16px;\n  }\n\n  .report-options-button-container {\n    width: 200px;\n    display: inline-flex;\n    flex-flow: row-reverse;\n    background-color: #050e25;\n  }\n\n  .container {\n    display: flex;\n    padding: 0;\n    height: 90%;\n    margin-top: 8px;\n    max-width: inherit;\n\n    input,\n    select {\n      margin-bottom: 50px;\n    }\n\n    .main-col {\n      max-width: -webkit-fill-available;\n    }\n\n    .map-title {\n      width: auto;\n      white-space: nowrap;\n      position: absolute;\n      left: 59px;\n      top: 0px;\n      font-size: 1.25rem;\n      padding: 5px;\n      z-index: 90;\n    }\n\n    .table-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      box-shadow: 0px 0px 20px #000;\n      display: flex;\n      position: relative;\n      margin-left: 1px;\n      margin-top: 10px;\n      max-height: 40vh;\n      overflow-y: auto;\n    }\n\n    .reportTable {\n      min-height: 10vh;\n      color: white;\n    }\n\n    .map-best-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      box-shadow: 0px 0px 20px #000;\n      display: flex;\n      position: relative;\n      height: 40vh;\n      width: 100%;\n      border-radius: 7px;\n      padding: 0px !important;\n    }\n\n    .map-legend {\n      width: 230px;\n      position: absolute;\n      border-radius: 5px;\n      padding: 5px;\n      right: 40px;\n      bottom: 10px;\n      padding-bottom: 10px;\n      background-color: #18244c;\n      z-index: 90;\n      height: 180px;\n    }\n\n    .map-legend p {\n      text-align: center;\n      height: 15px;\n    }\n\n    .map-legend span {\n      width: 100px;\n      margin-left: 5px;\n    }\n\n    .map-legend-div {\n      display: flex;\n      flex-flow: column;\n      height: 100%;\n      flex-wrap: wrap;\n    }\n\n    .map-legend-dot-div {\n      width: 70px;\n      margin-left: 5px;\n      white-space: nowrap;\n    }\n\n    .map-legend-dot {\n      background-color: #4b5ea6;\n      height: 14px;\n      width: 14px;\n      margin-left: 5px;\n      margin-right: 5px;\n      border-radius: 50%;\n      display: inline-flex;\n    }\n\n    .expand-container-summary {\n      position: absolute;\n      top: 59px;\n      left: 50px;\n      height: 90vh !important;\n      width: 95% !important;\n      z-index: 100;\n      padding-top: 45px !important;\n      overflow: scroll !important;\n      flex-flow: wrap;\n    }\n\n    .expand-summary-button {\n      display: unset;\n      position: absolute;\n      top: 1px;\n      left: 0px;\n      z-index: 1001;\n    }\n\n    .summary-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      box-shadow: 0px 0px 20px #000;\n      display: flex;\n      margin-top: 0px;\n      margin-left: 5px;\n      margin-right: 20px;\n      padding-top: 0px;\n      height: 40vh;\n      width: 250px;\n      overflow-x: hidden;\n      overflow-y: scroll;\n      flex-direction: column;\n      border-radius: 7px;\n    }\n\n    .card {\n      padding-left: 2px;\n      width: 210px;\n      line-height: 18px;\n      margin-bottom: 10px;\n      max-width: 210px;\n\n    }\n\n    .card-title {\n      line-height: 5px;\n      font-size: 1.2rem;\n    }\n\n    .summary-container-span {\n      font-size: 1.2rem;\n    }\n\n    .te-primary {\n      background-color: #050e25;\n    }\n\n    .te-secondary {\n      background-color: #4fc32c;\n    }\n\n    .te-blue {\n      background-color: #0b61bf;\n    }\n\n    .summary-button {\n      width: 44px;\n      display: inline-flex;\n      align-self: flex-end;\n      background-color: white;\n    }\n\n    .summary-top {\n      width: 100px;\n    }\n\n    .summary-field-double {\n      height: auto;\n      line-height: 18px;\n    }\n\n    .chart-line-container {\n      height: 100%;\n      width: 100%;\n      width: -moz-available;\n      width: -webkit-fill-available;\n      width: stretch;\n    }\n\n    .report-options {\n      margin-top: 20px;\n      text-align: right;\n      margin-right: 10px;\n\n      button {\n        background-color: #fff;\n        border: unset;\n        margin-left: 10px;\n      }\n\n      button:hover {\n        background-color: #257ee0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
